export type Supplier = {
  id: string;
  name: string;
};

export type Sku = {
  id: string;
  name: string;
  measurement: Measurement;
};
export type Measurement = {
  unit: string;
  quantity: number;
};

export enum InventorySearchOrderProperty {
  NAME = "NAME",
  STOCK_LEVEL = "STOCK_LEVEL",
  EXPIRY_DATE = "EXPIRY_DATE",
  UPDATED_AT = "UPDATED_AT",
}

export type PaginatedResult<PayloadT> = {
  edges: {
    node: PayloadT;
    cursor: string;
  }[];
  totalCount: number | null;
};
